const normalize = (text: string) =>
  text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replaceAll("²", "2")
    .replaceAll("³", "3")
    .replaceAll("ß", "ss");

export default {
  normalize,
};
